
import { Component, Vue, Prop } from 'vue-property-decorator';
import Subline from '../atoms/Subline.vue';
import Button from '../atoms/Button.vue';

@Component({
  components: {
    Subline,
    Button,
  },
})
export default class Card extends Vue {
  @Prop({ default: false }) isRounded!: boolean;
  @Prop({ default: '20px' }) rounded!: string;
  @Prop() backgroundColor!: string;
  @Prop({ default: '285px' }) height!: string;

  @Prop({ default: false }) isDark!: boolean; // DEPRECATED
  @Prop() text!: string; // DEPRECATED
  @Prop() buttonText!: string; // DEPRECATED

  get style() {
    return {
      background: this.backgroundColor,
      borderRadius: this.isRounded ? this.rounded : 0,
      height: this.height,
    };
  }
}
